import * as React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import "../../../assets/sass/components/operationalReport.scss";
import { ERROR_MSG, REPORT_TYPE, SUCCESS_MSG, T2 } from "./constant";
import CONSTANT from "../../constants/constantFile";
import Dropdown from "../../components/dropdown";
import DatePicker from "../../components/DatePicker";
import AlertMessage from "../../widgets/AlertMessageWidget";
import * as opActionCreators from "./actionCreators";
import { bindActionCreators } from "redux";
import Loader from "../Loader";
import { capitalize } from "../../utils/utils";
class OperationalReport extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            startDate: undefined,
            endDate: undefined,
            customerId: "",
            success: false,
            isTypeOptSelected: REPORT_TYPE[0].value,
            isApplyBtnClicked: false,
        };
    }
    componentDidUpdate() {
        if (this.props.showAlert && !this.props.isLoading) {
            setTimeout(() => {
                this.props.opReportActions.resetReport();
            }, CONSTANT.autoHideToasts);
        }
    }
    startDateChange = (date) => {
        this.setState({ startDate: date, endDate: undefined });
    };

    endDateChange = (date) => {
        this.setState({ endDate: date });
    };

    typeHandler = (value) => {
        this.setState({ isTypeOptSelected: value });
    };

    customerIdChange = (event) => {
        const { value } = event.target;
        this.setState({ customerId: value });
    };

    /* Dispatching Transaction List Action when Apply Handler Clicked */
    applyHandler = () => {
        this.setState({ isApplyBtnClicked: true, success: false });
        if (!this.state.isTypeOptSelected || !this.state.startDate || !this.state.endDate) {
            return false;
        }
        // this.makingTransactionListAPI();
        this.props.opReportActions.getReport(this.state);
        return true;
    };
    renderStartDateDatePicker = () => {
        const { startDate, isApplyBtnClicked } = this.state;
        return (
            <DatePicker
                placeHolder="From Date"
                id="fromDate"
                isError={isApplyBtnClicked && !startDate}
                onChange={this.startDateChange}
                disabled={false}
            />
        );
    };
    renderEndDateDatePicker = () => {
        const { startDate, endDate, isApplyBtnClicked } = this.state;
        return (
            <>
                <DatePicker
                    placeHolder="To Date"
                    fromDate={new Date(this.state.startDate)}
                    disabled={!this.state.startDate}
                    maxDays={T2.maxDays + 1}
                    isError={isApplyBtnClicked && !endDate}
                    id="toDate"
                    onChange={this.endDateChange}
                />
                {isApplyBtnClicked && !startDate && (
                    <div>
                        <span className="text-danger input-error-msg">{T2.dateMsg}</span>
                    </div>
                )}
                {isApplyBtnClicked && startDate && !endDate && (
                    <span className="text-danger input-error-msg">{T2.message}</span>
                )}
            </>
        );
    };
    renderReportTypeSelection = () => {
        const { isTypeOptSelected } = this.state;
        return (
            <div className="gaf-search">
                <Row>
                    <Col md={6}>
                        <div className="report-field-label">
                            <label>{T2.type}</label>
                        </div>
                        <Dropdown
                            menuItems={REPORT_TYPE}
                            onChangeReportType={this.typeHandler}
                            isError={this.state.isApplyBtnClicked && !isTypeOptSelected}
                        />
                        {this.state.isApplyBtnClicked && !isTypeOptSelected && (
                            <div>
                                <span className="text-danger input-error-msg">{T2.reportMsg}</span>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="report-field-label">
                            <label>{T2.dateRange}</label>
                        </div>
                        <div className="input-date-range">
                            {this.renderStartDateDatePicker()}
                            <span style={{ marginRight: "5px", marginLeft: "5px" }}> To </span>
                            {this.renderEndDateDatePicker()}
                        </div>
                        <div className="report-field-label">
                            <label>{T2.customerId}</label>
                        </div>
                        <div className="inputbox-rectangle">
                            <input className="gaf-inputBox" type="text" onChange={this.customerIdChange} />
                        </div>
                        <div className="btn-actions">
                            <Button
                                className="btn gaf-btn-primary generate-report-btn"
                                id="ph-apply-btn"
                                onClick={this.applyHandler}
                            >
                                {T2.submit}
                            </Button>
                        </div>
                    </Col>
                    {/* {this.renderDatePickerType()} */}
                </Row>
            </div>
        );
    };
    render() {
        const { userInfo } = this.props;
        const show = Object.keys(userInfo).length && (userInfo.isAdmin || userInfo.isTm);
        const selectedReportType = this.state.isTypeOptSelected;
        const reportType = capitalize(selectedReportType.replace(/([a-z](?=[A-Z]))/g, "$1 "));
        return show ? (
            <main className="operational-report-container pt100" id="operational-reports">
                {this.props.isLoading ? <Loader /> : null}
                {this.props.showAlert ? (
                    <div className="alert-container">
                        <AlertMessage
                            type={this.props.success ? "success" : "error"}
                            message={this.props.success ? SUCCESS_MSG(reportType) : ERROR_MSG}
                            closeAlert={() => {
                                this.props.opReportActions.resetReport();
                            }}
                        />
                    </div>
                ) : null}
                <div className="operational-report-title">Operational Report</div>
                <div className="operational-report-search">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 report-search">
                        {this.renderReportTypeSelection()}
                    </div>
                </div>
            </main>
        ) : (
            <Redirect to="/?provider=okta" />
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo || {},
        isLoading: state.operationalReportInfo.isLoading,
        success: state.operationalReportInfo.success,
        error: state.operationalReportInfo.errors,
        showAlert: state.operationalReportInfo.success || !!state.operationalReportInfo.errors,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        opReportActions: bindActionCreators(opActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OperationalReport);
